/**
* 系统管理  机构管理
*/
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>机构管理</el-breadcrumb-item>
    </el-breadcrumb>




  </div>
</template>

<script>
export default {
  name: "orgManage"
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/system/orgManage.vue